<div
  [class]="class()"
  class="symbol symbol-100px symbol-lg-150px symbol-fixed position-relative"
>
  <img [coreAvatar]="image()" alt="avatar" class="avatar-image" />
  <div class="upload-button">
    <label
      for="loadImage"
      class="btn btn-icon btn-circle w-30px h-30px bg-primary shadow"
    >
      <ui-keenicon name="pencil" class="fs-6 text-white"></ui-keenicon>
    </label>
    <input
      class="d-none"
      type="file"
      accept="image/*"
      (change)="onFileSelected($event)"
      id="loadImage"
    />
  </div>
  <div class="clear-button">
    <div
      class="btn btn-icon btn-circle w-30px h-30px bg-danger shadow"
      (click)="removeImage()"
      (keyup.enter)="removeImage()"
      tabindex="0"
      role="button"
      aria-label="Remove image"
    >
      <ui-keenicon name="cross" class="fs-3 text-white"></ui-keenicon>
    </div>
  </div>
  <div class="loader">
    @if (isLoading()) {
      <ui-loader [size]="'small'"></ui-loader>
    }
  </div>
</div>
